import React from "react";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";
import styles from "./ConfirmDeleteModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { setModalOpen } from "@/store/slices/globalSlice";
import { MODAL_ID } from "@/lib/constants";
import DANGER from "@/assets/png/Danger.png";
import { type RootState } from "@/store/rootReducer";

interface ConfirmDeleteModalProps {
  deleteLabel?: string;
  handleDelete: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  deleteLabel = "",
  handleDelete,
}) => {
  const { modalOpen } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(setModalOpen({ id: null, data: null }));
  };

  return (
    <Modal
      heading="Confirm Delete"
      modalOpen={modalOpen.id === MODAL_ID.CONFIRM_DELETE}
      closeModal={closeModal}
      className={styles.modal}
    >
      <img alt="" src={DANGER} className={styles.danger} />
      <h3> Delete {deleteLabel} </h3>
      <p>
        Are you sure you want to delete{" "}
        <strong>{modalOpen?.data?.userName || deleteLabel}</strong>
      </p>
      {modalOpen?.data?.used > 0 && (
        <p style={{ color: 'var(--text-2, #475569)', fontSize: '14px', lineHeight: '1.5', marginTop: '12px' }}>
          This is part of another assessment, so deleting it will also remove it from that assessment.        </p>
      )}
      <div className={styles.buttonContainer}>
        <Button className={styles.cancelButton} onClick={closeModal}>
          Cancel
        </Button>
        <Button className={styles.deleteButton} onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
